// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-input .v-icon[data-v-66f42e80]{color:#00f!important}", ""]);
// Exports
module.exports = exports;
